import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import OTMnr from './../workinstructions/images/OTM-nr.png';
import OTMscratch01 from './../workinstructions/images/OTMscratch01.png';
import OTMscratch02 from './../workinstructions/images/OTMscratch02.png';
import delotmshipment01 from './../workinstructions/images/deleteotmshipment01.png';
import delotmshipment02 from './../workinstructions/images/deleteotmshipment02.png';
import delotmshipment03 from './../workinstructions/images/deleteotmshipment03.png';
import shipmentAWB from './../workinstructions/images/shipmentAWB.png';

class OTM extends React.Component {
    
    componentDidMount() {
		 document.title = "OTM";    
        // Check if there's a hash in the URL and scroll to that section
        if (window.location.hash) {
            const targetId = window.location.hash.substring(1); // Remove the # from hash
            setTimeout(() => {
                const element = document.getElementById(targetId);
                if (element) {
                    // Calculate scroll position with offset to show the heading properly
                    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                    const offsetPosition = elementPosition - 100; // Adjust this value as needed
                    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }, 100);
        }
    }

    render() {
        return (
            <div>

                <h1 className="page-header">Outbound</h1>
                <Panel>
                    <PanelHeader>Outbound</PanelHeader>
                    <PanelBody>
                    <h2>OTM for ALU-outbound & OTM from scratch for RLC</h2>
						<h2>OTM ALU-basic</h2>						
						<p>Go to Manage deliveries =&gt; for Red order fill first 0 in then the delivery-nr, for White orders only scan in delivery-Nr  
						=&gt; Enter =&gt; select OTM =&gt; click on "Actions" =&gt; Click on "Routing Options" =&gt; at "Transport Mode" select Courier =&gt;
						Click Show Options for Red order select Express, for 12:00h Red order select deliver before 12:00, for White orders select Economic
						=&gt; Click OK =&gt; Close Screen =&gt; Go back to Manage deliveries =&gt; click on + =&gt; When the indicator is green then you can do the next step, Click on "Buy Shipment" =&gt; Click on delivery =&gt; 
						=&gt; Click on "Specific Field" =&gt; Fill phone-number of from shipment-paper in field "phone" =&gt; Enter =&gt;
						Select OTM =&gt; click on "Actions" =&gt; Click "Secure Options" =&gt; close screen =&gt; click on Manage Result =&gt;
						click on "Buy shipment" =&gt; go to "documents" =&gt; click on "glasses"-icon =&gt; CTRL+P to printout AWB
						</p>
						<p>
							If there is error , then you can try to fill the pickingdate is today
						</p>
						
						<h2>Scratch order release in OTM</h2>						
						<p>Send it economic
						At Source Location ID fill in FI26 for Tilburg =&gt; At Destination Location ID click on search-icon =&gt; select the right name and attention =&gt; click on "Finished"=&gt; at Source ERP SCRATCH =&gt;
						at DN Reference fill in IR-SCRAP Xvak =&gt; at ICO Term fill in "DAP"=&gt; then fill in info of pallet/colli. YUou have to fill in weight,height,length,width manually =&gt; Save =&gt;
						at DGR select "N"=&gt; click on "submit"=&gt; copy the OTM-number. That will be start with the date of today =&gt; Go to Manage Deliveries Finder and paste the OTM-nr in =&gt; then process further as normal.=&gt;
	                    <p> <img src={OTMnr} alt="OTM Number" style={{ maxWidth: '100%', height: 'auto' }} /> </p>				
						In "Courier Specific Fields "Go to DHL Shipping Account and fill in 191983782 <br/>
	                  		Destination-ID of DHL genevillier is 3370001817
							
                            copy the OTM-nr and paste it in Manage deliveries Finder and processing further like other OTM-creation<br />
							<p> <img src={OTMnr} alt="OTM-Nr starting with date of the delivery-creation" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
							<p> <img src={OTMscratch01} alt="Release OTM from scratch specific fields" style={{ maxWidth: '100%', height: 'auto' }} /> </p>		
							<p> <img src={OTMscratch02} alt="Release OTM from scratch specific fields" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							Start VT02N go to tab Text -header-note 3 fill in AWB<br/>
							<p> <img src={shipmentAWB} alt="Start VT02N to to tab Text -header-note 3 fill in AWB" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
						</p>
						<h2>Delete shipment/delivery in OTM</h2>						
						<p>Go to manage deliveries =&gt; fill in de delivery-nr =&gt; select OTM by clicking =&gt; click on "buy shipment" =&gt; click on the icons on right of the OTM-nr </p>
	                    <p> <img src={delotmshipment01} alt="Delete delivery in OTM" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
						<p>in the next screeen click on "OK"</p>
						<p> <img src={delotmshipment02} alt="Delete delivery in OTM" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
						<p>in modal "Actions" select "Withdraw Tender" =&gt; get back to "Actions" =&gt; go to " Order management" =&gt; unassign order release =&gt; select unassign order - buy</p>
		 				<p> <img src={delotmshipment03} alt="Delete delivery in OTM" style={{ maxWidth: '100%', height: 'auto' }} /> </p>	
						
                    </PanelBody>
                    <footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
                      <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
                        &copy; Nov 2025 by TQT Tong. All rights reserved.
                      </p>
                    </footer>
                            
                </Panel>
        
            </div>
        )
    }
}

export default OTM;


























